import { render } from "./CustomizationSummaryDialog.vue?vue&type=template&id=5c79832a&scoped=true"
import script from "./CustomizationSummaryDialog.vue?vue&type=script&lang=js"
export * from "./CustomizationSummaryDialog.vue?vue&type=script&lang=js"

import "./CustomizationSummaryDialog.vue?vue&type=style&index=0&id=5c79832a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c79832a"]])

export default __exports__